import React, { useEffect, useRef, useState } from "react";
import { Redirect, withRouter } from "react-router-dom";
import { renderRoutes, matchRoutes } from "react-router-config";
import { connect } from "react-redux";
import { parse } from "query-string";

import { GlobalProvider as ColbiUIProvider } from "colbi_web_ui/lib/state/GlobalProvider";
import { GlobalProvider } from "../../state/globalProvider";

import { ArrowBack } from "mosaic-react-icons";
import { mapProperties, hydrateRoute, stringifyFilter } from "colbi_web_ui/lib/utils";

import { ImageRender, LoadingIndicator } from "colbi_web_ui/lib/components";
import Header from "colbi_web_ui/lib/components/layout/Header/Header";
import ModalController from "../App/ModalController/ModalController";
import DialogController from "../App/DialogController/DialogController";
import { UserRoles } from "../../enums/userRoles";
import {
    logout,
    pushModal,
    pushDialog,
    popModal,
    uploadAction,
    toggleMenu,
    setLocale,
    auditNoteSubmit,
    removeModal,
    setDataFileStatusAction,
    deleteFilePermanentlyAction,
    deleteInvalidFilePermanentlyAction,
    reprocessRepositoryAction,
    downloadAction,
    downloadFilesAction,
    downloadFileAction,
    hideFileAction,
    reprocessFileAction,
    deleteFilePermanentlyByPathAction,
} from "../../store/actions";
import { filteredNavigationByModules, filteredQueriesByModules } from "./navigation";
import I18n from "../../I18n";
import theme from "../../style/_theme.json";
import proxy from "../../routes/proxy";
import styles from "./Repository.module.sass";
import { format } from "../../utils";
import socketIOClient from "socket.io-client";
import configsByTheme from "../../enums/configsByTheme";
import { getOrganizationName } from "../../utils/camelize";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { mapProjectContext } from "../../utils/mapProjectsByOrganization";
import { submitTicketFormData } from "../../store/actions/modalActions";
import RepositoryStatus from "../../components/RepositoryStatus/RepositoryStatus";
import { REACT_APP_COLBI_THEME } from "../../environmentVariables";

import SovosProvider from "mosaic-react/sovos-provider";
import SovosNavigation from "mosaic-react/sovos-navigation";
import {
    footerProps,
    setAccount,
    decodeUserSession,
    buildStaticLinks,
} from "../../utils/utils";
import LanguageDialog from "../../components/LanguageDialog/LanguageDialog";
import { cleanPropertiesNestedInMenu, findProjectById } from "../../utils/mapPropertiesForMenu";
import { checkAccessByRole } from "../../utils/roleValidatorUtil";
import { deepLink } from "../../utils/routingUtils";

const tabs = [
    {
        section: "activity",
        label: "Activity",
        createType: "Activity",
    },
    {
        section: "folders",
        label: "Folders",
        createType: "Folder",
    },
];

const appTheme = REACT_APP_COLBI_THEME ? REACT_APP_COLBI_THEME.toLocaleLowerCase() : "";
const asideMenuLogo = configsByTheme(appTheme)["icon"];
const localesByAppTheme = configsByTheme(appTheme)["locales"];
const freshDeskFormTitleByAppTheme = configsByTheme(appTheme)["freshDeskFormTitle"];

const Provider = ({ children, ...props }) => {
    return (
        <GlobalProvider {...props}>
            <ColbiUIProvider {...props}>{children}</ColbiUIProvider>
        </GlobalProvider>
    );
};

const logo = () => {
    return (
        appTheme && <ImageRender icon={`${appTheme && appTheme.length ? asideMenuLogo : "logo"}`} />
    );
};

const Repository = (props) => {
    const {
        user,
        uploads,
        fetch,
        match,
        setLocale,
        location,
        toggleMenu,
        logout,
        history,
        pushModal,
        popModal,
        menu,
        reload,
        pushDialog,
        uploadFiles,
        submitAuditNote,
        route,
        setDataFileStatus,
        deleteFilePermanently,
        deleteInvalidFilePermanently,
        hideFile,
        downloadFile,
        reprocessRepository,
        downloadFiles,
        download,
        modules,
        submitTicket,
        reprocessFiles,
        deleteFilePermanentlyByPath,
    } = props;

    const locale = match.params.locale || "en";
    const i18n = I18n.use(locale);

    const [isLanguageModalOpen, setIsLanguageModalOpen] = useState(false);
    const [userLocale, setUserLocale] = useState(locale);
    const [selectedLink, setSelectedLink] = useState(i18n("overview"));

    useEffect(() => {
        if (location && location.state && location.state.selectedLink) {
            setSelectedLink(i18n(location.state.selectedLink));
        }
    }, [location, i18n]);

    useEffect(() => {
        const pop = history.action === "POP";
        if (!pop && !fetch.activity) {
            if (location.hash) {
                const scrollElement = window.document.querySelector(location.hash);
                if (scrollElement && scrollElement.previousElementSibling) {
                    const headerOffset = 70;

                    const previousRect =
                        scrollElement.previousElementSibling.getBoundingClientRect();
                    let stuckOffset = previousRect.height;
                    const elementPosition = scrollElement.offsetTop;
                    const offsetPosition = elementPosition - headerOffset - stuckOffset - 100;

                    setTimeout(() => {
                        window.scrollTo({
                            top: offsetPosition,
                            behavior: "smooth",
                        });
                    }, 0);
                }
            } else if (location.search.search("page") === -1) {
                setTimeout(() => {
                    window.scrollTo(0, 0);
                }, 0);
            }
        }
    }, [fetch.activity, location.hash, location.pathname, location.search, history.action]);

    useEffect(() => {
        setLocale(locale);
    }, [locale, setLocale]);

    const [beforeLoad, setBeforeLoad] = useState(true);
    const userInformation = decodeUserSession(user);
    const socketOptions = {
        reconnection: false,
        path: "/socket.io",
    };

    const setupSockets = () => {
        const socket = socketIOClient(socketOptions);
        socket.on(`${match.params.projectId}_notifications`, (data) => {
            setNotifications((prevState) => [...prevState, data]);
        });
        socket.on("connect_error", (err) => console.log("SocketIO cannot reach the server"));
    };

    const setupSocketsRef = useRef(setupSockets);

    useEffect(() => {
        setupSocketsRef.current();
    }, []);

    const [notifications, setNotifications] = useState([]);

    const projectId = match.params.projectId;

    const queryParams = parse(location.search) || {};
    const routeParams = match.params || {};
    const params = {
        ...queryParams,
        ...routeParams,
    };

    //Data for menu
    const { menuOrganizationProject = [] } = mapProperties(
        {
            menuOrganizationProject: "query(0).list",
        },
        fetch.results,
        fetch.status,
        Repository.queries(match.params),
        props,
        match.params,
        i18n,
        locale,
    );

    const { organizationProjects = {} } = mapProperties(
        {
            organizationProjects: "query(1)",
        },
        fetch.results,
        fetch.status,
        Repository.queries(match.params),
        props,
        match.params,
        i18n,
        locale,
    );

    const folderData = (
        fetch.results[`${locale}_folder_data_projectId_${projectId}`] || {
            list: [],
        }
    ).list;

    let tempNavigation = filteredNavigationByModules(modules || []);

    const folderDataNav = folderData.map(({ fileType, fileTypeCount, fileTypeFiscalYears }) => {
        const yearsByType = (fileTypeFiscalYears || []).map(({ fiscalYear, count }) => {
            return {
                name: `${i18n`${fiscalYear}`} (${format(count, "normal", null, 0)})`,
                level: 2,
                to: `/:projectId/repository/folders/${fiscalYear}/${fileType}`,
            };
        });

        return {
            name: `${i18n`${fileType}`} (${format(fileTypeCount, "normal", null, 0)})`,
            level: 1,
            navigation: [...yearsByType],
        };
    });

    const mergeDataNav = folderData.map(({ fileType, fileTypeFiscalYears }) => {
        const yearsByType = (fileTypeFiscalYears || []).map(({ fiscalYear }) => {
            return {
                name: `${i18n`${fiscalYear}`}`,
                level: 2,
                to: `/:projectId/repository/merge_collisions/${fiscalYear}/${fileType}`,
            };
        });

        return {
            name: `${i18n`${fileType}`}`,
            level: 1,
            navigation: [...yearsByType],
        };
    });

    const project = organizationProjects
        ? (organizationProjects.projects || []).find(({ id }) => id === projectId) || {
              name: "",
          }
        : { name: "" };

    const { maxFiscalYear: organizationMaxFiscalYear } = organizationProjects;

    const mapProjectToNavigate = mapProjectContext(
        project,
        projectId,
        organizationProjects,
        organizationMaxFiscalYear,
    );

    if (
        mapProjectToNavigate &&
        mapProjectToNavigate.fiscalYears &&
        Object.keys(mapProjectToNavigate.fiscalYears).length !== 0 &&
        mapProjectToNavigate.to &&
        !modules.includes("archive")
    ) {
        tempNavigation.push({
            name: "label(Overview)",
            to: `${mapProjectToNavigate.to}`,
            exact: true,
            icon: ArrowBack,
        });
    }
    const navigationNav = mapProperties(
        { navigation: tempNavigation },
        (fetch || {}).results,
        (fetch || {}).status,
        Repository.queries(params),
        {
            ...props,
            folderData: folderDataNav,
            mergeData: mergeDataNav,
        },
        params,
        i18n,
        locale,
    );

    let currentNav = navigationNav?.navigation?.map((obj) => {
        const { navigation, ...rest } = obj;
        return rest;
    });

    const staticLinks = buildStaticLinks(currentNav, history, match.params, i18n);

    useEffect(() => {
        deepLink(staticLinks, location.pathname, setSelectedLink);
    }, [staticLinks, location]);

    if (!userInformation) {
        return <Redirect to={"/login"} push />;
    }

    if (userInformation && userInformation.expired) {
        return <Redirect to={`/${locale}/reset_password`} />;
    }

    const isToDisplaySupportIcon =
        (fetch.results[`${locale}_is_to_display_support_icon`] || "false").toLocaleLowerCase() ===
        "true";

    const ticketSubjectEnvironment = fetch.results[`${locale}_get_environment_to_subject`] || "";
    if (!projectId) {
        return <Redirect to={`${locale ? `/${locale}` : ""}/`} />;
    }
    const currentSection = params.section;
    const hydrated = hydrateRoute(route.path, { ...params });

    if (userInformation && checkAccessByRole(userInformation, [UserRoles.BACKOFFICE])) {
        return <Redirect to={`/${locale}/settings/`} />;
    }

    if (!currentSection) {
        return <Redirect to={`${hydrated}${tabs[0].section}/status`} replace />;
    }
    if (params.section === "activity" && !params.fiscalYear) {
        return <Redirect to={`${hydrated}status`} replace />;
    }

    const repositoryStatus = fetch.results[
        `${locale}_repository_status_fiscalYear_${match.params.fiscalYear}_projectId_${projectId}`
    ] ||
        fetch.results[`${locale}_repository_status_projectId_${projectId}`] || {
            repoStatus: 0,
        };

    const routeQueries = (route.queries && route.queries(params)) || [];

    if (modules.includes("archive") && beforeLoad) {
        route.components.shift();
        setBeforeLoad(false);
    }

    const children = (route.components || []).map((c, index) => {
        const Component = c.component;

        const componentProps = mapProperties(
            match.isExact ? { ...c.props, modules } : { ...c.props, checkbox: false },
            (fetch || {}).results,
            (fetch || {}).status,
            routeQueries,
            props,
            params,
            i18n,
            locale,
        );

        if (componentProps && componentProps.onClickPushModal) {
            const { view, title } = componentProps.onClickPushModal;
            componentProps.onClick = (e) => {
                e.originalEvent.preventDefault();
                e.originalEvent.stopPropagation();
                const data = e.target.value || {};
                pushModal({
                    title: i18n`${title}`,
                    data: {
                        projectId: params.projectId,
                        ...data,
                    },
                    args: { ...params, ...data },
                    view: `${view}Form`,
                })
                    .then(() => reload && reload())
                    .catch(() => null);
            };
        }
        return (
            <Component
                key={index}
                modifiers={c.modifiers}
                {...componentProps}
                active={fetch.activity}
            />
        );
    });

    const branch = matchRoutes([route, ...(route.routes || [])], location.pathname);

    const branchQueries = branch.reduce((allQueries, { route }) => {
        const innerQueries = route.queries ? route.queries(params) : [];
        allQueries = [...allQueries, ...innerQueries];
        return allQueries;
    }, []);

    const downloadableQueries = branchQueries.filter(({ downloadable }) => downloadable);

    const goto = (page, filters, anchor) => {
        const pageUrl = page
            ? (typeof page.join === "function" ? page.join("/") : page).replace(/\/+/g, "/")
            : null;
        const urlFilters = filters ? stringifyFilter(filters) : "";
        const localePrefixed = pageUrl
            ? `${locale ? `/${locale}${!pageUrl.match(/^\//) ? "/" : ""}` : ""}`
            : null;
        const gotoPage = pageUrl
            ? `${localePrefixed}${pageUrl}${urlFilters.length ? `?filter=${urlFilters}` : ""}`
            : `${location.pathname}?filter=${urlFilters}${anchor ? `#${anchor}` : ""}`;
        history.push(gotoPage);
    };

    const metadata = getOrganizationName(organizationProjects, project);

    const organizationSelectedInMenu = (menuOrganizationProject || []).find(({ nestedAccounts }) =>
        (nestedAccounts || []).some(({ id }) => id === projectId),
    );

    const { accounts, selectedAccount } = cleanPropertiesNestedInMenu(
        menuOrganizationProject,
        organizationSelectedInMenu,
    );

    return (
        <SovosProvider>
            <Provider
                user={userInformation}
                proxy={proxy}
                theme={theme}
                actions={{
                    pushModal,
                    pushDialog,
                    popModal,
                    uploadFiles,
                    submitTicket,
                    submitAuditNote,
                    removeModal,
                    setDataFileStatus,
                    deleteFilePermanently,
                    deleteInvalidFilePermanently,
                    hideFile,
                    reprocessRepository,
                    logout,
                    downloadFiles,
                    downloadFile,
                    setLocale: (locale) => {
                        history.push(`/${locale}${history.location.pathname.substring(3)}`);
                    },
                    goto,
                    download,
                    reprocessFiles,
                    deleteFilePermanentlyByPath,
                }}
                i18n={i18n}
                locale={locale || localesByAppTheme[0].id}
                locales={localesByAppTheme}
                reload={reload}
                params={params}
                history={history}
                location={location}
                repositoryStatus={repositoryStatus}
                uploads={uploads}
            >
                <div className={styles["app"]}>
                    <div className={`${styles["aside"]} `}>
                        <SovosNavigation
                            product="APR SAF-T"
                            accounts={accounts}
                            selectedAccount={findProjectById(selectedAccount, projectId)}
                            links={staticLinks}
                            selectedLink={selectedLink}
                            setAccount={(account) => {
                                account["id"] = account["id"].split("_").pop();
                                setAccount(account, locale, history, proxy, params);
                            }}
                            FooterProps={footerProps(
                                history,
                                locale,
                                userInformation,
                                setIsLanguageModalOpen,
                                logout,
                                i18n,
                            )}
                        />

                        <LanguageDialog
                            isOpen={isLanguageModalOpen}
                            setIsOpen={setIsLanguageModalOpen}
                            i18n={i18n}
                            setUserLocale={setUserLocale}
                            userLocale={userLocale}
                            localesByAppTheme={localesByAppTheme}
                            setLocale={setLocale}
                            history={history}
                        />
                    </div>
                    <div className={styles["main"]}>
                        <RepositoryStatus modules={modules} />
                        <Header
                            className={styles["header"]}
                            logout={logout}
                            proxy={proxy}
                            theme={theme}
                            title={
                                params.section === "folders"
                                    ? [i18n`${params.section || ""}`, params.fiscalYear]
                                    : i18n`${params.section || ""}`
                            }
                            toggleMenu={toggleMenu}
                            settingsAction={userInformation.accessSettings}
                            downloadableQueries={downloadableQueries}
                            expanded={menu !== "expanded"}
                            project={project}
                            navigation={navigationNav.navigation}
                            organizations={{ organizations: menuOrganizationProject }}
                            menuLogo={logo}
                            notifications={notifications.length}
                            notificationList={notifications}
                            menuTitle={i18n`Repository`}
                            displaySupportIcon={isToDisplaySupportIcon}
                            environment={`${ticketSubjectEnvironment} - ${
                                (project || {}).taxRegistrationNumber
                            }`}
                            emailFrom={userInformation.email}
                            name={userInformation.name}
                            metadata={metadata}
                            freshDeskModalTitle={freshDeskFormTitleByAppTheme}
                        />
                        <main
                            className={`${styles["content"] || ""} ${styles["foreground"] || ""}`}
                        >
                            {fetch.activity && (
                                <LoadingIndicator
                                    className={`${styles["loading-indicator"]} ${
                                        menu === "expanded" ? "" : styles["small-margin"]
                                    }`}
                                />
                            )}
                            {children}

                            {renderRoutes(route.routes)}
                        </main>
                    </div>
                    <ModalController popModal={popModal} />
                    <DialogController i18n={i18n} />
                    <ToastContainer />
                </div>
            </Provider>
        </SovosProvider>
    );
};

Repository.queries = (args, modules) => {
    const queries = filteredQueriesByModules(modules);

    const deepCopyQueries = JSON.parse(JSON.stringify(queries));
    if (deepCopyQueries) {
        //needed to change arguments to the respective value
        deepCopyQueries.forEach((query) =>
            Object.keys(query.args).forEach((k) =>
                query.args[k] ? query.args[k] : (query.args[k] = args[k] || query.args[k]),
            ),
        );
    }
    const allQueries = [
        {
            resource: "menu_organizations_projects",
            body: "id,name,typeEntity,nestedAccounts{id,name,typeEntity}",
            forceRefresh: true,
        },
        {
            resource: "organization_projects_by_projectId",
            args: {
                projectId: args.projectId,
            },
            body: "id,name,maxFiscalYear,projects{id,name,fiscalYears,status,taxRegistrationNumber,active,projectExpired,metadata,modules{navigation_by_import_id,name,default_route,default_module}},organizationExpired, organizationActive, maxFiscalYear",
            forceRefresh: true,
        },
        {
            resource: "folder_data",
            args: {
                projectId: args.projectId,
            },
            body: "fileType, fileTypeCount, fileTypeFiscalYears{fiscalYear,count}",
        },
        {
            resource: "application_version",
            body: "version",
        },
        {
            resource: "is_to_display_support_icon",
        },
        {
            resource: "get_environment_to_subject",
        },
        ...deepCopyQueries,
    ];

    if (modules && modules.includes("merge_collisions")) {
        allQueries.push({
            resource: "repository_status",
            args: {
                projectId: args.projectId || "",
                fiscalYear: args.fiscalYear || "",
            },
            body: "repoStatus,fiscalYear,fileType,autoMerge",
        });
    }

    return allQueries;
};

export default connect(
    ({ user, fetch, menu, uploads }) => ({
        user,
        fetch,
        menu,
        uploads,
    }),
    {
        logout,
        pushModal,
        popModal,
        removeModal,
        toggleMenu,
        setLocale,
        pushDialog,
        setDataFileStatus: setDataFileStatusAction,
        deleteFilePermanently: deleteFilePermanentlyAction,
        downloadFiles: downloadFilesAction,
        hideFile: hideFileAction,
        downloadFile: downloadFileAction,
        deleteInvalidFilePermanently: deleteInvalidFilePermanentlyAction,
        reprocessRepository: reprocessRepositoryAction,
        uploadFiles: uploadAction,
        submitTicket: submitTicketFormData,
        submitAuditNote: auditNoteSubmit,
        download: downloadAction,
        reprocessFiles: reprocessFileAction,
        deleteFilePermanentlyByPath: deleteFilePermanentlyByPathAction,
    },
)(withRouter(Repository));
